var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page p-6"},[_c('h1',{staticClass:"text-4xl mb-4"},[_vm._v(_vm._s(_vm.entry.title))]),_vm._v(" "),_c('hr',{staticClass:"mb-4"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.entry.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }